import { fetchAPI } from "../apiutil";

export const versionAPI = {
  loadVersion: async () => {
    return fetchAPI("/api/version", {
      method: "GET",
    });
  },
};
